import { createSelector } from 'reselect';
import { getCustomEventList } from '../../../common/selectors/DruidSelectors';
import { COLUMN_TYPE, buildColumn } from '../../../common/support/utils';
import type { IColumn } from '../../../common/types/IColumn';
import type { ColumnOptions, GetColumnKeys, GetColumnOptions } from './createColumnsSelector.types';
export const getCustomEventColumns = (customEvents: string[], options?: ColumnOptions): IColumn[] => {
  return customEvents.map((key) => buildColumn({ type: COLUMN_TYPE.CUSTOM_EVENT, key, ...options }));
};

export const createCustomEventColumnsSelector = (
  getCustomEventKeys: GetColumnKeys = getCustomEventList,
  getColumnOptions: GetColumnOptions = () => undefined
) => {
  return createSelector(getCustomEventKeys, getColumnOptions, getCustomEventColumns);
};
